export default "__VITE_ASSET__KhxT$8D3__"